import React, { useEffect, useState, useCallback, useRef } from "react";
import { Modal, Form, Input, Select, Checkbox, Space, Radio, Spin, AutoComplete, Button, message, Modal as AntModal, Tag, Row, Col } from "antd";
import { PlusOutlined, DeleteOutlined, MailOutlined, PhoneOutlined, CheckCircleOutlined, SendOutlined, LockOutlined } from "@ant-design/icons";
import { Wrapper } from "../style";
import { MakeApiCall } from "../../../../apis";
import { primaryColor } from "../../../../config";

const { Option } = Select;

// Common country codes — code only, no flags
const COUNTRY_CODES = [
    { code: '+1',   country: 'US/CA' },
    { code: '+7',   country: 'Russia' },
    { code: '+20',  country: 'Egypt' },
    { code: '+27',  country: 'South Africa' },
    { code: '+30',  country: 'Greece' },
    { code: '+31',  country: 'Netherlands' },
    { code: '+32',  country: 'Belgium' },
    { code: '+33',  country: 'France' },
    { code: '+34',  country: 'Spain' },
    { code: '+36',  country: 'Hungary' },
    { code: '+39',  country: 'Italy' },
    { code: '+40',  country: 'Romania' },
    { code: '+41',  country: 'Switzerland' },
    { code: '+43',  country: 'Austria' },
    { code: '+44',  country: 'UK' },
    { code: '+45',  country: 'Denmark' },
    { code: '+46',  country: 'Sweden' },
    { code: '+47',  country: 'Norway' },
    { code: '+48',  country: 'Poland' },
    { code: '+49',  country: 'Germany' },
    { code: '+51',  country: 'Peru' },
    { code: '+52',  country: 'Mexico' },
    { code: '+54',  country: 'Argentina' },
    { code: '+55',  country: 'Brazil' },
    { code: '+56',  country: 'Chile' },
    { code: '+57',  country: 'Colombia' },
    { code: '+60',  country: 'Malaysia' },
    { code: '+61',  country: 'Australia' },
    { code: '+62',  country: 'Indonesia' },
    { code: '+63',  country: 'Philippines' },
    { code: '+64',  country: 'New Zealand' },
    { code: '+65',  country: 'Singapore' },
    { code: '+66',  country: 'Thailand' },
    { code: '+81',  country: 'Japan' },
    { code: '+82',  country: 'South Korea' },
    { code: '+84',  country: 'Vietnam' },
    { code: '+86',  country: 'China' },
    { code: '+90',  country: 'Turkey' },
    { code: '+91',  country: 'India' },
    { code: '+92',  country: 'Pakistan' },
    { code: '+93',  country: 'Afghanistan' },
    { code: '+94',  country: 'Sri Lanka' },
    { code: '+95',  country: 'Myanmar' },
    { code: '+98',  country: 'Iran' },
    { code: '+212', country: 'Morocco' },
    { code: '+213', country: 'Algeria' },
    { code: '+216', country: 'Tunisia' },
    { code: '+218', country: 'Libya' },
    { code: '+220', country: 'Gambia' },
    { code: '+234', country: 'Nigeria' },
    { code: '+254', country: 'Kenya' },
    { code: '+255', country: 'Tanzania' },
    { code: '+256', country: 'Uganda' },
    { code: '+260', country: 'Zambia' },
    { code: '+263', country: 'Zimbabwe' },
    { code: '+351', country: 'Portugal' },
    { code: '+352', country: 'Luxembourg' },
    { code: '+353', country: 'Ireland' },
    { code: '+358', country: 'Finland' },
    { code: '+380', country: 'Ukraine' },
    { code: '+381', country: 'Serbia' },
    { code: '+385', country: 'Croatia' },
    { code: '+386', country: 'Slovenia' },
    { code: '+420', country: 'Czech Republic' },
    { code: '+421', country: 'Slovakia' },
    { code: '+880', country: 'Bangladesh' },
    { code: '+966', country: 'Saudi Arabia' },
    { code: '+971', country: 'UAE' },
    { code: '+972', country: 'Israel' },
    { code: '+973', country: 'Bahrain' },
    { code: '+974', country: 'Qatar' },
    { code: '+975', country: 'Bhutan' },
    { code: '+977', country: 'Nepal' },
    { code: '+994', country: 'Azerbaijan' },
    { code: '+998', country: 'Uzbekistan' },
];

function AddNewAlerts({
    isModalVisible,
    handleCancel,
    handleSubmit,
    editing,
    userData,
    asinList,
    alertCategories,
    alertDataMap,
    fetchProductList,
    isSearching,
    hasMore,
    page,
    searchText
}) {

    const [form] = Form.useForm();
    const receiveOnWatch = Form.useWatch('receive_on', form);
    const [alertTypes, setAlertTypes] = useState({});
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedAlertType, setSelectedAlertType] = useState(null);
    const [alertLogicType, setAlertLogicType] = useState(null);
    const [localSelectedAsins, setLocalSelectedAsins] = useState([]);
    
    // Email management
    const [emails, setEmails] = useState([]);
    const [pendingEmail, setPendingEmail] = useState(null);
    const [emailInput, setEmailInput] = useState('');
    const [emailSuggestions, setEmailSuggestions] = useState([]);
    const [emailOtpModalVisible, setEmailOtpModalVisible] = useState(false);
    const [emailOtpCode, setEmailOtpCode] = useState('');
    const [emailOtpLoading, setEmailOtpLoading] = useState(false);
    const [preVerifiedEmails, setPreVerifiedEmails] = useState([]); // Track pre-verified emails from API
    
    // WhatsApp management
    const [whatsappNumbers, setWhatsappNumbers] = useState([]);
    const [pendingWhatsapp, setPendingWhatsapp] = useState(null);
    const [whatsappCountryCode, setWhatsappCountryCode] = useState('+91');
    const [whatsappInput, setWhatsappInput] = useState('');
    const [whatsappSuggestions, setWhatsappSuggestions] = useState([]);
    const [mobileOtpModalVisible, setMobileOtpModalVisible] = useState(false);
    const [mobileOtpCode, setMobileOtpCode] = useState('');
    const [mobileOtpLoading, setMobileOtpLoading] = useState(false);
    const [preVerifiedMobiles, setPreVerifiedMobiles] = useState([]); // Track pre-verified mobiles from API
    
    // Suggestions state
    const [allEmailSuggestions, setAllEmailSuggestions] = useState([]);
    const [allMobileSuggestions, setAllMobileSuggestions] = useState([]);
    const [suggestionsLoading, setSuggestionsLoading] = useState(false);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => { isMounted.current = false; };
    }, []);

    // Fetch suggestions when modal opens
    useEffect(() => {
        if (!isModalVisible) return;

        const fetchSuggestions = async () => {
            setSuggestionsLoading(true);
            try {
                const response = await MakeApiCall(
                    'get-contact-details-suggestions',
                    'get',
                    null,
                    true,
                    {},
                    userData?.token
                );
                if (!isMounted.current) return;
                if (response?.status) {
                    const emails = (response.data?.emails || []).map(e => ({ value: e, label: e }));
                    const mobiles = (response.data?.mobile_numbers || []).map(n => ({ value: n, label: n }));
                    setAllEmailSuggestions(emails);
                    setAllMobileSuggestions(mobiles);
                    setEmailSuggestions(emails);
                    setWhatsappSuggestions(mobiles);
                    
                    // Store pre-verified emails and mobiles (these don't need OTP)
                    setPreVerifiedEmails(response.data?.emails || []);
                    setPreVerifiedMobiles(response.data?.mobile_numbers || []);
                }
            } catch (e) {
                console.error('Failed to fetch contact suggestions:', e);
            } finally {
                if (isMounted.current) setSuggestionsLoading(false);
            }
        };

        fetchSuggestions();
    }, [isModalVisible, userData?.token]);

    const handlePopupScroll = useCallback((e) => {
        const { target } = e;
        if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
            if (!isSearching && hasMore) {
                fetchProductList(searchText, page + 1, true);
            }
        }
    }, [isSearching, hasMore, page, searchText, fetchProductList]);

    useEffect(() => {
        const types = {};
        Object.entries(alertDataMap.types).forEach(([category, typeMap]) => {
            types[category] = Object.entries(typeMap).map(([key, label]) => ({
                label,
                value: key
            }));
        });
        setAlertTypes(types);

        if (editing) {
            let asinArray = [];
            try {
                asinArray = typeof editing.asin_list === "string" ? JSON.parse(editing.asin_list) : editing.asin_list;
            } catch (err) {
                console.error("Failed to parse asin_list:", err);
            }
            setLocalSelectedAsins(Array.isArray(asinArray) ? asinArray : []);
            const logic = alertDataMap.logicTypeMap?.[editing.type]?.type || "Default";
            setAlertLogicType(logic);
        } else {
            setLocalSelectedAsins([]);
            setAlertLogicType(null);
        }
    }, [alertDataMap.types, alertDataMap.logicTypeMap, editing]);

    useEffect(() => {
        if (editing) {
            let frequencyValue = 2;
            let daysValue = null;

            if (editing.frequency !== "Everytime") {
                frequencyValue = 1;
                daysValue = parseInt(editing.frequency, 10);
            }

            // Parse existing emails
            let emailList = [];
            if (editing?.send_on_emails) {
                if (Array.isArray(editing.send_on_emails)) {
                    emailList = editing.send_on_emails;
                } else if (typeof editing.send_on_emails === 'string') {
                    emailList = editing.send_on_emails.split(',').map(e => e.trim());
                }
            }
            setEmails(emailList);

            // Parse existing WhatsApp numbers
            let whatsappList = [];
            if (editing?.send_on_mobile_numbers) {
                if (Array.isArray(editing.send_on_mobile_numbers)) {
                    whatsappList = editing.send_on_mobile_numbers;
                } else if (typeof editing.send_on_mobile_numbers === 'string') {
                    whatsappList = editing.send_on_mobile_numbers.split(',').map(w => w.trim());
                }
            } else if (editing?.send_on_mobile_number) {
                whatsappList = [editing.send_on_mobile_number];
            }
            setWhatsappNumbers(whatsappList);

            form.setFieldsValue({
                ...editing,
                alertType: editing.type,
                frequency: frequencyValue,
                days: daysValue,
                receive_on: editing.receive_on || [],
                severity: editing.severity || "Medium",
            });

            setSelectedCategory(editing.category);
            setSelectedAlertType(editing.type);
        } else {
            form.resetFields();
            setSelectedCategory(null);
            setSelectedAlertType(null);
            setAlertLogicType(null);
            setEmails([]);
            setWhatsappNumbers([]);
            setEmailInput('');
            setWhatsappInput('');
            setWhatsappCountryCode('+91');
            setPendingEmail(null);
            setPendingWhatsapp(null);
            form.setFieldsValue({
                frequency: 2,
                severity: "Medium",
            });
        }
    }, [editing, isModalVisible]);

    // Email OTP handlers
    const sendEmailOTP = async (email) => {
        setEmailOtpLoading(true);
        try {
            const response = await MakeApiCall(
                'verification/send-email-otp',
                'post',
                { email: email },
                true,
                {},
                userData?.token
            );
            
            if (response?.status) {
                message.success('OTP sent successfully to your email!');
                setPendingEmail(email);
                setEmailOtpModalVisible(true);
            } else {
                message.error(response?.message || 'Failed to send OTP');
            }
        } catch (error) {
            message.error('Failed to send OTP');
        } finally {
            setEmailOtpLoading(false);
        }
    };

    const verifyEmailOTP = async () => {
        if (!emailOtpCode || emailOtpCode.length !== 6) {
            message.warning('Please enter a valid 6-digit OTP');
            return;
        }
        
        setEmailOtpLoading(true);
        try {
            const response = await MakeApiCall(
                'verification/verify-email-otp',
                'post',
                { 
                    email: pendingEmail,
                    otp: emailOtpCode 
                },
                true,
                {},
                userData?.token
            );
            
            if (response?.status) {
                message.success('Email verified successfully!');
                setEmails([...emails, pendingEmail]);
                setEmailInput('');
                setPendingEmail(null);
                setEmailOtpModalVisible(false);
                setEmailOtpCode('');
            } else {
                message.error(response?.message || 'Invalid OTP');
            }
        } catch (error) {
            message.error('Failed to verify OTP');
        } finally {
            setEmailOtpLoading(false);
        }
    };

    const handleAddEmail = () => {
        if (!emailInput || !emailInput.trim()) {
            message.warning('Please enter an email address');
            return;
        }
        
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(emailInput)) {
            message.error('Please enter a valid email address');
            return;
        }
        
        if (emails.includes(emailInput)) {
            message.warning('Email already exists and verified');
            return;
        }
        
        // Check if email is already pending
        if (pendingEmail === emailInput) {
            message.warning('Email is already pending verification');
            return;
        }
        
        // Check if email is pre-verified (from suggestions)
        if (preVerifiedEmails.includes(emailInput)) {
            // Add directly without OTP verification
            setEmails([...emails, emailInput]);
            setEmailInput('');
            message.success('Email added successfully!');
            return;
        }
        
        // Send OTP for verification only for new emails
        sendEmailOTP(emailInput);
    };

    const handleRemoveEmail = (emailToRemove) => {
        setEmails(emails.filter(email => email !== emailToRemove));
    };

    // Mobile OTP handlers
    const sendMobileOTP = async (mobileNumber, countryCode) => {
        const fullNumber = `${countryCode}${mobileNumber}`;
        setMobileOtpLoading(true);
        try {
            const response = await MakeApiCall(
                'verification/send-mobile-otp',
                'post',
                { contact_no: fullNumber },
                true,
                {},
                userData?.token
            );
            
            if (response?.status) {
                message.success('OTP sent successfully to your mobile number!');
                setPendingWhatsapp({ number: mobileNumber, countryCode, fullNumber });
                setMobileOtpModalVisible(true);
            } else {
                message.error(response?.message || 'Failed to send OTP');
            }
        } catch (error) {
            message.error('Failed to send OTP');
        } finally {
            setMobileOtpLoading(false);
        }
    };

    const verifyMobileOTP = async () => {
        if (!mobileOtpCode || mobileOtpCode.length !== 6) {
            message.warning('Please enter a valid 6-digit OTP');
            return;
        }
        
        setMobileOtpLoading(true);
        try {
            const response = await MakeApiCall(
                'verification/verify-mobile-otp',
                'post',
                { 
                    contact_no: pendingWhatsapp.fullNumber,
                    otp: mobileOtpCode 
                },
                true,
                {},
                userData?.token
            );
            
            if (response?.status) {
                message.success('Mobile number verified successfully!');
                const fullNumberWithCode = `${pendingWhatsapp.countryCode}-${pendingWhatsapp.number}`;
                setWhatsappNumbers([...whatsappNumbers, fullNumberWithCode]);
                setWhatsappInput('');
                setPendingWhatsapp(null);
                setMobileOtpModalVisible(false);
                setMobileOtpCode('');
            } else {
                message.error(response?.message || 'Invalid OTP');
            }
        } catch (error) {
            message.error('Failed to verify OTP');
        } finally {
            setMobileOtpLoading(false);
        }
    };

    const handleAddWhatsapp = () => {
        if (!whatsappInput || !whatsappInput.trim()) {
            message.warning('Please enter a WhatsApp number');
            return;
        }
        
        const numberRegex = /^[0-9]{6,14}$/;
        if (!numberRegex.test(whatsappInput)) {
            message.error('Please enter a valid number (6-14 digits only)');
            return;
        }
        
        const fullNumber = `${whatsappCountryCode}-${whatsappInput}`;
        if (whatsappNumbers.includes(fullNumber)) {
            message.warning('WhatsApp number already exists and verified');
            return;
        }
        
        // Check if number is already pending
        if (pendingWhatsapp && pendingWhatsapp.number === whatsappInput && pendingWhatsapp.countryCode === whatsappCountryCode) {
            message.warning('Number is already pending verification');
            return;
        }
        
        // Check if mobile number is pre-verified (from suggestions)
        const fullNumberWithoutHyphen = `${whatsappCountryCode}${whatsappInput}`;
        if (preVerifiedMobiles.includes(fullNumberWithoutHyphen)) {
            // Add directly without OTP verification
            setWhatsappNumbers([...whatsappNumbers, fullNumber]);
            setWhatsappInput('');
            message.success('WhatsApp number added successfully!');
            return;
        }
        
        // Send OTP for verification only for new numbers
        sendMobileOTP(whatsappInput, whatsappCountryCode);
    };

    const handleRemoveWhatsapp = (whatsappToRemove) => {
        setWhatsappNumbers(whatsappNumbers.filter(whatsapp => whatsapp !== whatsappToRemove));
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            
            // Validate emails if WhatsApp/Email is selected
            if (values.receive_on?.includes('Email') && emails.length === 0) {
                message.error('Please add at least one email address');
                return;
            }
            
            if (values.receive_on?.includes('Whatsapp') && whatsappNumbers.length === 0) {
                message.error('Please add at least one WhatsApp number');
                return;
            }

            const payload = {
                name: values.name,
                category: values.category,
                type: values.alertType,
                frequency: values.frequency === 1 ? `${values.days}` : "Everytime",
                receive_on: values.receive_on || [],
                asin_list: localSelectedAsins || [],
                severity: values.severity,
                send_on_emails: emails,
                send_on_mobile_numbers: whatsappNumbers,
            };

            if (alertDataMap.logicTypeMap?.[values.alertType]?.type === "Custom") {
                payload.user_input = values.user_input;
            }

            handleSubmit(payload);
        } catch (errorInfo) {
            console.log("Validation Failed:", errorInfo);
        }
    };

    return (
        <>
            <Modal
                open={isModalVisible}
                title={editing ? "Edit Alerts" : "Add New Alerts"}
                onCancel={handleCancel}
                width={750}
                destroyOnClose
                footer={[
                    <React.Fragment key="footer-btns">
                        <button type="button" className="btn btn-light me-3" onClick={handleCancel}>Close</button>
                        <button type="button" className="btn btn-danger" onClick={handleOk}>{editing ? "Update" : "Save"}</button>
                    </React.Fragment>
                ]}
            >
                <Wrapper>
                    <div className="modal_custom add-alert">
                        <Form form={form} layout="vertical" name="expenseForm" initialValues={{ frequency: 2, severity: "Medium" }}>

                            <div className="row g-5 mb-0 align-items-center">
                                <div className="col-md-12">
                                    <Form.Item label="" name="name" className="mb-0 fw-bold"
                                               rules={[{required: true, message: "Please enter alert name"}]}>
                                        <Input className="form-control form-control-solid fs-7"
                                               placeholder="Enter Alert Name"/>
                                    </Form.Item>
                                </div>

                                <div className="col-md-6">
                                    <Form.Item shouldUpdate={() => true} noStyle>
                                        {({ getFieldError }) => {
                                            const errors = getFieldError('category');
                                            return (
                                                <Form.Item
                                                    label=""
                                                    required
                                                    className="mb-4 fw-bold"
                                                    validateStatus={errors.length ? "error" : ""}
                                                    help={errors.length > 0 && (
                                                        <div style={{ marginTop: '10px', color: '#ff4d4f' }}>
                                                            {errors[0]}
                                                        </div>
                                                    )}
                                                >
                                                    <Form.Item name="category" noStyle rules={[{ required: true, message: "Please select a category" }]}>
                                                        <Select
                                                            placeholder="Select Category"
                                                            onChange={(value) => {
                                                                setSelectedCategory(value);
                                                                form.setFieldsValue({alertType: undefined});
                                                            }}
                                                        >
                                                            {alertCategories.map(option => (
                                                                <Option key={option.value} value={option.value}>{option.label}</Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Form.Item>
                                            );
                                        }}
                                    </Form.Item>
                                </div>

                                <div className="col-md-6">
                                    <Form.Item shouldUpdate={() => true} noStyle>
                                        {({ getFieldError }) => {
                                            const errors = getFieldError('alertType');
                                            return (
                                                <Form.Item
                                                    label=""
                                                    required
                                                    className="mb-4"
                                                    validateStatus={errors.length ? "error" : ""}
                                                    help={errors.length > 0 && (
                                                        <div style={{ marginTop: '10px', color: '#ff4d4f' }}>
                                                            {errors[0]}
                                                        </div>
                                                    )}
                                                >
                                                    <Form.Item name="alertType" noStyle rules={[{ required: true, message: "Please select an alert type" }]}>
                                                        <Select
                                                            placeholder="Select Alert Type"
                                                            disabled={!selectedCategory}
                                                            onChange={(value) => {
                                                                setSelectedAlertType(value);
                                                                const logic = alertDataMap.logicTypeMap?.[value]?.type || "Default";
                                                                setAlertLogicType(logic);
                                                                form.setFieldsValue({user_input: null});
                                                            }}
                                                        >
                                                            {alertTypes[selectedCategory]?.map((option) => (
                                                                <Option key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </Option>
                                                            )) || null}
                                                        </Select>
                                                    </Form.Item>
                                                </Form.Item>
                                            );
                                        }}
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    <Form.Item className="fw-bold mb-4" label="">
                                        <Select
                                            mode="tags"
                                            showSearch
                                            placeholder="Search SKU, Title or ASIN"
                                            className="w-100"
                                            size="large"
                                            value={localSelectedAsins}
                                            onChange={setLocalSelectedAsins}
                                            onSearch={(val) => fetchProductList(val, 1, false)}
                                            onPopupScroll={handlePopupScroll}
                                            filterOption={false}
                                            loading={isSearching}
                                            optionLabelProp="value"
                                            maxTagCount={"responsive"}
                                            tokenSeparators={[',']}
                                            notFoundContent={isSearching ? <div className="text-center p-2"><Spin size="small"/></div> : null}
                                        >
                                            {asinList.map((item) => (
                                                <Option key={item.asin} value={item.asin}>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <img
                                                            src={item.image || "https://app.sellerview.ai/sellerview_api/images/no-product-image.png"}
                                                            alt=""
                                                            className="w-40px h-40px rounded border object-fit-contain"
                                                        />
                                                        <div className="flex-grow-1" style={{minWidth: 0}}>
                                                            <div className="fw-bolder text-dark text-truncate" style={{fontSize: '12px'}}>
                                                                {item.name}
                                                            </div>
                                                            <div className="fs-12 text-muted d-flex align-items-center" style={{gap: '8px'}}>
                                                                <span className="badge badge-light-danger fw-bold">{item.asin}</span>
                                                                {item.sku && (
                                                                    <span className="text-truncate" style={{maxWidth: '160px'}}>
                                                                        <small>SKU: <span className="fw-bold text-dark">{item.sku}</span></small>
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Option>
                                            ))}
                                            {isSearching && hasMore && (
                                                <Option disabled key="loading-more" className="text-center bg-light">
                                                    <Spin size="small" /> <small className="ms-2">Loading more...</small>
                                                </Option>
                                            )}
                                        </Select>
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    {alertLogicType === "Custom" && (
                                        <div className="col-md-12">
                                            <Form.Item
                                                label=""
                                                name="user_input"
                                                className="mb-4"
                                                rules={[{required: true, message: "Please enter a threshold value"}]}
                                            >
                                                <Space>
                                                    <div className="fw-bold fs-7">
                                                        {alertDataMap.logicTypeMap?.[selectedAlertType]?.description || "Enter threshold percentage"}
                                                    </div>
                                                    <Input
                                                        type="number"
                                                        className="w-125px fs-7"
                                                        placeholder="Percentage"
                                                        suffix="%"
                                                        variant="filled"
                                                        size="large"
                                                    />
                                                </Space>
                                            </Form.Item>
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-12">
                                    <Form.Item name="frequency" className="d-flex align-items-center fw-bold">
                                        <Radio.Group name="notificationFrequency">
                                            <Space direction="vertical">
                                                <Radio value={1}>
                                                    Send me a notification every
                                                    <Form.Item noStyle shouldUpdate={(p, c) => p.frequency !== c.frequency}>
                                                        {({getFieldValue}) => (
                                                            <Form.Item
                                                                name="days"
                                                                noStyle
                                                                rules={[{ required: getFieldValue('frequency') === 1, message: "Required" }]}
                                                            >
                                                                <Input
                                                                    type="number"
                                                                    min={1}
                                                                    className="w-125px mx-3 fs-7"
                                                                    variant="filled"
                                                                    disabled={getFieldValue('frequency') !== 1}
                                                                />
                                                            </Form.Item>
                                                        )}
                                                    </Form.Item>
                                                    day(s)
                                                </Radio>
                                                <Radio className="mt-3" value={2}>
                                                    Send me a notification every time the change happens.
                                                </Radio>
                                            </Space>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    <Form.Item
                                        name="severity"
                                        label="Severity"
                                        className="fw-bold"
                                        rules={[{required: true, message: "Please select a severity level"}]}
                                    >
                                        <Radio.Group>
                                            <Radio value="Minor">Minor</Radio>
                                            <Radio value="Major">Major</Radio>
                                            <Radio value="Critical">Critical</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    <Form.Item name="receive_on" className="fw-bold" label="Receive Alert On">
                                        <Checkbox.Group>
                                            {alertDataMap.receive_on.map((option) => (
                                                <Checkbox key={option} value={option}>{option}</Checkbox>
                                            ))}
                                        </Checkbox.Group>
                                    </Form.Item>
                                </div>

                                {/* Email field with separate add and verify functionality */}
                                {receiveOnWatch?.includes('Email') && (
                                    <div className="col-md-12">
                                        <div className="fw-bold mb-2">
                                            <MailOutlined className="me-2" />
                                            Email Addresses
                                        </div>
                                        
                                        {/* Verified Emails List */}
                                        {emails.length > 0 && (
                                            <div className="mb-3">
                                                <div className="text-muted mb-2 small">Verified Emails:</div>
                                                {emails.map((email, index) => (
                                                    <div key={index} className="mb-2 d-flex align-items-center justify-content-between" style={{ padding: '8px', backgroundColor: '#f0f9f0', borderRadius: '4px', border: '1px solid #b7eb8f' }}>
                                                        <div className="d-flex align-items-center">
                                                            <CheckCircleOutlined className="text-success me-2" />
                                                            <span>{email}</span>
                                                            <Tag color="success" className="ms-2" style={{ fontSize: '10px' }}>Verified</Tag>
                                                        </div>
                                                        <Button 
                                                            type="text" 
                                                            danger 
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => handleRemoveEmail(email)}
                                                            size="small"
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {/* Add New Email Section */}
                                        <div className="mb-3">
                                            <div className="text-muted mb-2 small">Add New Email:</div>
                                            <Row gutter={8}>
                                                <Col span={18}>
                                                    <AutoComplete
                                                        style={{ width: '100%' }}
                                                        options={emailSuggestions}
                                                        onSearch={(searchVal) => {
                                                            if (!searchVal) {
                                                                setEmailSuggestions(allEmailSuggestions);
                                                            } else {
                                                                setEmailSuggestions(
                                                                    allEmailSuggestions.filter(s =>
                                                                        s.value.toLowerCase().includes(searchVal.toLowerCase())
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                        value={emailInput}
                                                        onChange={setEmailInput}
                                                        placeholder="Enter email address"
                                                        notFoundContent={suggestionsLoading ? <div className="text-center p-2"><Spin size="small" /></div> : null}
                                                    />
                                                </Col>
                                                <Col span={6}>
                                                    <Button 
                                                        type="primary" 
                                                        icon={<SendOutlined />}
                                                        onClick={handleAddEmail}
                                                        loading={emailOtpLoading}
                                                        block
                                                        danger
                                                        className="h-40px"
                                                    >
                                                        Add Email
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )}

                                {/* WhatsApp field with separate add and verify functionality */}
                                {receiveOnWatch?.includes('Whatsapp') && (
                                    <div className="col-md-12">
                                        <div className="fw-bold mb-2">
                                            <PhoneOutlined className="me-2" />
                                            WhatsApp Numbers
                                        </div>
                                        
                                        {/* Verified WhatsApp Numbers List */}
                                        {whatsappNumbers.length > 0 && (
                                            <div className="mb-3">
                                                <div className="text-muted mb-2 small">Verified Numbers:</div>
                                                {whatsappNumbers.map((whatsapp, index) => {
                                                    const [code, number] = whatsapp.split('-');
                                                    return (
                                                        <div key={index} className="mb-2 d-flex align-items-center justify-content-between" style={{ padding: '8px', backgroundColor: '#f0f9f0', borderRadius: '4px', border: '1px solid #b7eb8f' }}>
                                                            <div className="d-flex align-items-center">
                                                                <CheckCircleOutlined className="text-success me-2" />
                                                                <span>{code} {number}</span>
                                                                <Tag color="success" className="ms-2" style={{ fontSize: '10px' }}>Verified</Tag>
                                                            </div>
                                                            <Button 
                                                                type="text" 
                                                                danger 
                                                                icon={<DeleteOutlined />}
                                                                onClick={() => handleRemoveWhatsapp(whatsapp)}
                                                                size="small"
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {/* Add New WhatsApp Section */}
                                        <div className="mb-3">
                                            <div className="text-muted mb-2 small">Add New Number:</div>
                                            <Row gutter={8}>
                                                <Col span={6}>
                                                    <Select
                                                        value={whatsappCountryCode}
                                                        onChange={setWhatsappCountryCode}
                                                        showSearch
                                                        filterOption={(input, option) =>
                                                            option?.value?.includes(input)
                                                        }
                                                        style={{ width: '100%' }}
                                                        dropdownStyle={{ minWidth: 110 }}
                                                        popupMatchSelectWidth={false}
                                                    >
                                                        {COUNTRY_CODES.map(({ code }) => (
                                                            <Option key={code} value={code}>{code}</Option>
                                                        ))}
                                                    </Select>
                                                </Col>
                                                <Col span={12}>
                                                    <AutoComplete
                                                        style={{ width: '100%' }}
                                                        options={whatsappSuggestions}
                                                        onSearch={(searchVal) => {
                                                            if (!searchVal) {
                                                                setWhatsappSuggestions(allMobileSuggestions);
                                                            } else {
                                                                setWhatsappSuggestions(
                                                                    allMobileSuggestions.filter(s =>
                                                                        s.value.includes(searchVal)
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                        value={whatsappInput}
                                                        onChange={setWhatsappInput}
                                                        placeholder="Enter WhatsApp number"
                                                        notFoundContent={suggestionsLoading ? <div className="text-center p-2"><Spin size="small" /></div> : null}
                                                    />
                                                </Col>
                                                <Col span={6}>
                                                    <Button 
                                                        type="primary" 
                                                        danger
                                                        icon={<SendOutlined />}
                                                        onClick={handleAddWhatsapp}
                                                        loading={mobileOtpLoading}
                                                        block
                                                        className="h-40px"
                                                    >
                                                        Add Number
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Form>
                    </div>
                </Wrapper>
            </Modal>

            {/* Email OTP Verification Modal */}
            <AntModal
                title="Verify Email Address"
                open={emailOtpModalVisible}
                onCancel={() => {
                    setEmailOtpModalVisible(false);
                    setEmailOtpCode('');
                    setPendingEmail(null);
                }}
                footer={[
                    
                    <Button color="default" variant="filled" key="cancel" onClick={() => {
                        setEmailOtpModalVisible(false);
                        setEmailOtpCode('');
                        setPendingEmail(null);
                    }}>
                        Cancel
                    </Button>,
                    <Button key="verify" danger type="primary" icon={<LockOutlined />} onClick={verifyEmailOTP} loading={emailOtpLoading}>
                        Verify OTP
                    </Button>
                ]}
            >
                <div className="text-center">
                    <i class="ki-duotone ki-sms " style={{color: primaryColor, fontSize: 50}}>
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                    <p>We've sent a 6-digit OTP to</p>
                    <p className="fw-bold fs-5">{pendingEmail}</p>
                    <Input.OTP
                        inputType="numeric"
                        length={6}
                        value={emailOtpCode}
                        onChange={setEmailOtpCode}
                        className="mb-3 h-40px"
                        style={{ fontSize: '24px', letterSpacing: '8px', textAlign: 'center' }}
                        autoFocus
                        prefix={<LockOutlined className="text-muted" />}
                    />
              
                    <p className="text-muted small mt-3">Please enter the verification code sent to your email</p>
                    <Button 
                        type="link" 
                        onClick={() => sendEmailOTP(pendingEmail)}
                        disabled={emailOtpLoading}
                    >
                        Resend OTP
                    </Button>
                </div>
            </AntModal>

            {/* Mobile OTP Verification Modal */}
            <AntModal
                title="Verify Mobile Number"
                open={mobileOtpModalVisible}
                onCancel={() => {
                    setMobileOtpModalVisible(false);
                    setMobileOtpCode('');
                    setPendingWhatsapp(null);
                }}
                footer={[
                    <Button color="default" variant="filled" key="cancel" onClick={() => {
                        setMobileOtpModalVisible(false);
                        setMobileOtpCode('');
                        setPendingWhatsapp(null);
                    }}>
                        Cancel
                    </Button>,
                    <Button key="verify" type="primary" danger icon={<LockOutlined />} onClick={verifyMobileOTP} loading={mobileOtpLoading}>
                        Verify OTP
                    </Button>
                ]}
            >
                <div className="text-center">
                <i class="ki-duotone ki-phone" style={{color: primaryColor, fontSize: 50}}>
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                    <p className="mt-3">We've sent a 6-digit OTP to</p>
                    <p className="fw-bold fs-5">{pendingWhatsapp?.countryCode} {pendingWhatsapp?.number}</p>
                    <Input
                        placeholder="Enter OTP"
                        value={mobileOtpCode}
                        onChange={(e) => setMobileOtpCode(e.target.value)}
                        maxLength={6}
                        className="text-center mb-3"
                        style={{ fontSize: '24px', letterSpacing: '8px' }}
                        prefix={<LockOutlined className="text-muted" />}
                    />
                    <p className="text-muted small">Please enter the verification code sent to your mobile number</p>
                    <Button 
                        type="link" 
                        onClick={() => sendMobileOTP(pendingWhatsapp?.number, pendingWhatsapp?.countryCode)}
                        disabled={mobileOtpLoading}
                    >
                        Resend OTP
                    </Button>
                </div>
            </AntModal>
        </>
    );
}

export default AddNewAlerts;